import { TranslationMessages } from 'react-admin';
import englishMessages from 'ra-language-english';
import messages from 'paperman-translations';

const customEnglishMessages: TranslationMessages = {
  ...englishMessages,
  ...messages['en'],
};

export default customEnglishMessages;
